import { getAppVersion } from '$tablet-app/src/app/utils/version';
import { spacing } from '@akin-home/theme';
import { isWebBuild, useResponsiveStyling } from '@akin-home/utils/native';
import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import styled from 'styled-components/native';
import { AvatarComponent } from '../components/AvatarComponent';
import { BackHeader } from '../components/BackHeader';
import { LoginScreenViewProps } from './types';

export const LandscapeLoginScreenView = (props: LoginScreenViewProps) => {
  const { chat_item } = props;

  const version = getAppVersion();

  const { vs, mvs, ms } = useResponsiveStyling();

  return (
    <Container style={{ paddingVertical: vs(20), gap: vs(80) }}>
      <Left>
        <ScrollView contentContainerStyle={{ gap: vs(25) }}>
          <LogoImage
            resizeMode="contain"
            source={require('../assets/heypixi-logo.png')}
          />

          {chat_item ? chat_item : null}
        </ScrollView>

        <AvatarComponent
          style={[styles.avatarComponent]}
          size={Math.min(
            mvs(185, 0.5, { max: 200 }),
            ms(185, 0.5, { max: 200 })
          )}
        />
      </Left>

      <Right>
        <ScrollView contentContainerStyle={styles.scrollViewContentContainer}>
          <Panel>
            {props.onPressBack ? (
              <BackHeader
                style={styles.backHeader}
                onPress={props.onPressBack}
              />
            ) : null}

            <BodyContainer>{props.body}</BodyContainer>

            {!isWebBuild() ? (
              <VersionText>App Version: {version}</VersionText>
            ) : null}
          </Panel>
        </ScrollView>
      </Right>
    </Container>
  );
};

const Container = styled(View)({
  flex: 1,
  backgroundColor: '#f6f7f9',
  paddingHorizontal: 20,
  flexDirection: 'row',
  position: 'relative',
});

const Panel = styled(View)`
  background-color: white;
  border-radius: 20px;
  padding: 20px;
  gap: ${spacing[2]}px;

  height: 100%;
  align-items: center;
  justify-content: center;
`;

const Left = styled(View)`
  flex: 2;
`;

const Right = styled(View)`
  flex: 3;
`;

const LogoImage = styled.Image`
  width: 160px;
  height: 60px;
`;

const BodyContainer = styled(View)`
  min-height: 85%;
  align-items: center;
  width: 100%;
`;

const VersionText = styled.Text`
  font-family: Inter-Regular;
  font-size: 13px;
  position: absolute;
  bottom: 5px;
  right: 10px;
`;

const styles = StyleSheet.create({
  backHeader: {
    marginBottom: 'auto',
  },
  avatarComponent: {
    alignItems: 'flex-end',
    marginTop: spacing[3],
  },
  scrollViewContentContainer: {
    padding: spacing[2],
    gap: 16,
    flexGrow: 1,
  },
});
